import styled from 'styled-components';

export const FundsContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  background: #fff;
  border: 1px solid #e2e2e2;
  padding: 16px;
  border-radius: 8px;

  h4 {
    font-size: 16px;
    font-weight: 600;
    line-height: 20px;
    letter-spacing: 0em;
    text-align: left;
    color: #2b313d;
    width: calc(100% - 50px);
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
`;

export const FundsHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  margin-bottom: 8px;

  button {
    background: transparent;
    outline: none;
    border: none;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
  }
`;

export const FundsBody = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  border-top: 1px solid #cdd4df;
  padding: 8px 0;

  h4 {
    font-weight: 500;
  }

  ul {
    margin: 0;
    padding: 0;
    max-height: 300px;
    overflow-y: auto;
    padding-right: 5px;
  }
`;

export const FundItemStyle = styled.li`
  width: 100%;
  display: flex;
  height: 48px;
  align-items: center;
  justify-content: space-between;
  background-color: #f3f3ff;
  border-radius: 8px;
  padding: 0 8px 0 16px;
  margin-top: 10px;
  position: relative;
  border: 1px solid #f3f3ff;
  transition: all 0.25s ease-in-out;
  &:hover {
    border: 1px solid #7888f5;
  }
  input {
    width: 100%;
    background: #3d3bff33;
    height: 80%;
    outline: none;
    border: none;
    border-radius: 5px;
    padding: 0 10px;
  }

  h5 {
    font-size: 16px;
    font-weight: 500;
    line-height: 19px;
    letter-spacing: 0em;
    text-align: left;
    color: #5c5d61;
    overflow: hidden;
    display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
  }

  .actions {
    display: flex;
    align-items: center;
    gap: 6px;
    margin-left: 7px;

    button {
      background: none;
      border: none;
      outline: none;
      cursor: pointer;
    }
  }

  .toggler {
    background: none;
    border: none;
    outline: none;
    cursor: pointer;
  }
`;

export const HeaderElements = styled.div`
  display: flex;
  align-items: center;
`;

export const DeleteButton = styled.button`
  display: flex;
  outline: none;
  border: none;
  background-color: transparent;
  cursor: pointer;
  padding: 0;
  svg {
    width: 18px;
    height: 18px;
  }
`;

export const ActionButton = styled.div`
  display: flex;
`;

export const FundsMoreActionsList = styled.ul`
  margin: 0;
  padding: 0;
  border: 1px solid #7888f5;
  border-radius: 12px;
  overflow: hidden;
  box-shadow:
    0px 7px 15px 0px rgba(0, 0, 0, 0.1),
    0px 27px 27px 0px rgba(0, 0, 0, 0.09),
    0px 62px 37px 0px rgba(0, 0, 0, 0.05),
    0px 110px 44px 0px rgba(0, 0, 0, 0.01),
    0px 171px 48px 0px rgba(0, 0, 0, 0);

  li {
    min-width: 148px;
    height: 43px;
    display: flex;
    align-items: center;

    background: #ffffff;
    border-bottom: 1px solid #e2e2e2;

    overflow: hidden;

    button {
      width: 100%;
      height: 100%;
      display: flex;
      align-items: center;
      gap: 8px;
      text-align: left;
      padding: 0;
      padding: 0 16px;
      background: transparent;
      outline: none;
      border: none;
      cursor: pointer;
      font-size: 16px;
      font-weight: 400;
      line-height: 19px;
      letter-spacing: 0em;
      text-align: left;
      color: rgba(92, 93, 97, 1);
      &:hover {
        background: #f3f3ff;
      }
    }
  }
`;
